// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"page_loadingIndicator__Mu75Y"};